/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('PublicFilesBankCtrl', function(
    $scope,
    ErrorThrower,
    FileBank,
    Certificates,
    hub_api_url
) {
  const errorManager   = new ErrorThrower;

  $scope.files = [];
  $scope.certificates = [];
  
  $scope.formatDownloadUrl = function() {
    $scope.files.forEach(file => {
      file.download_url = hub_api_url + '/intra/my-files/' + file.filename;
    });
  };

  FileBank.query().$promise
    .then( files => {
	  $scope.files = files.hits;
	  $scope.formatDownloadUrl();
	})
	.catch(error => errorManager.minor(error.statusText));

  Certificates.query().$promise
	.then( result => {
	  const certificates = [];
	  for (let cert of result) {
		certificates.push({
		  download_url: `${hub_api_url}/intra/my-certificates/${cert.name}`,
		  label: cert.label,
		});
	  }
	  console.log(certificates);
	  $scope.certificates = certificates;
	})
	.catch(error => errorManager.minor(error.statusText));
});
